//BookShelf.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
// import Tooltip from '../../components/utils/Tooltip';
import BookShelfListComponent from './BookShelfListComponent';
import './styles/BookShelf.css';

const BookShelf = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();

    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [bookId, setBookId] = useState(null);

    const [isMyBooksHovered, setIsMyBooksHovered] = useState(false);
    const [isFlyingOnTheWallHovered, setIsFlyingOnTheWallHovered] = useState(false);
    const [isDcrHovered, setIsDcrHovered] = useState(false);

    const handleMyBooksMouseEnter = () => {
        setIsMyBooksHovered(true);
    };

    const handleMyBooksMouseLeave = () => {
        setIsMyBooksHovered(false);
    };

    const handleFlyingOnTheWallMouseEnter = () => {
        setIsFlyingOnTheWallHovered(true);
    };

    const handleFlyingOnTheWallMouseLeave = () => {
        setIsFlyingOnTheWallHovered(false);
    };

    const handleDcrMouseEnter = () => {
        setIsDcrHovered(true);
    };

    const handleDcrMouseLeave = () => {
        setIsDcrHovered(false);
    };

    const handleFlyingOnTheWallClick = () => {
        navigate('/flyersonthewall', { state: { bookId: 'All', bookTitle: 'All', ownerId: userId, ownerName: userName, fromPage: "bookShelfTop" } });
    };

    const handleDcrClick = () => {
        navigate("/dcrlist", { state: { bookId: 'All', bookTitle: 'All', ownerId: userId, ownerName: userName, fromPage: "bookShelfTop" } });
    };

    return (
        <div className="overflow-x-hidden">
            <div className="min-h-screen bg-black">
                <h3 className='py-4 text-xl lg:text-2xl font-bold text-yellow-200 text-center border-b border-blue-500'>My BookShelf</h3>
                <div className="grid grid-cols-3 gap-2 place-items-center">
                    <button
                        id='mybooks'
                        className='p-2 text-white text-xs'
                        style={{
                            backgroundColor: isMyBooksHovered ? '#007b00' : '#007bff',
                            transition: 'background-color 0.3s'
                        }}
                        onMouseEnter={handleMyBooksMouseEnter}
                        onMouseLeave={handleMyBooksMouseLeave}
                    >
                        My Books
                    </button>
                    <button
                        id='mybooks'
                        className='p-2 text-white text-xs'
                        style={{
                            backgroundColor: isFlyingOnTheWallHovered ? '#007b00' : '#007bff',
                            transition: 'background-color 0.3s'
                        }}
                        onMouseEnter={handleFlyingOnTheWallMouseEnter}
                        onMouseLeave={handleFlyingOnTheWallMouseLeave}
                        onClick={() => handleFlyingOnTheWallClick()}
                    >
                        Flyers On The Wall
                    </button>
                    <button
                        id='coreaders'
                        className='text-gray-100 p-2 text-xs'
                        style={{
                            backgroundColor: isDcrHovered ? '#007b00' : '#007bff',
                            transition: 'background-color 0.3s'
                        }}
                        disabled={true}
                        onMouseEnter={handleDcrMouseEnter}
                        onMouseLeave={handleDcrMouseLeave}
                        onClick={() => handleDcrClick()}
                    >
                        Co-Readers
                    </button>
                </div>
                <div className="full-width-container">
                    <BookShelfListComponent />
                </div>
            </div>
            <footer className="sticky bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
                <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
                <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
                <div className="flex flex-wrap justify-center md:justify-start gap-2 sm:gap-6 text-xs sm:text-sm">
                    <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
                    <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
                    <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
                </div>
                </div>
            </footer>
        </div>
    );
};

export default BookShelf;
